import React, { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useLocation } from "react-router-dom";
import { EASE, DURATIONS, prefersReducedMotion } from "../../lib/motion";

/**
 * PageTransition — orchestrates fade+lift between routes.
 * The top bar lives OUTSIDE this wrapper (in App), so it never flickers.
 */
export const PageTransition = ({ children }) => {
  const location = useLocation();
  const reduce = prefersReducedMotion();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [location.pathname]);

  if (reduce) {
    return <div key={location.pathname}>{children}</div>;
  }

  return (
    <AnimatePresence mode="wait" initial={false}>
      <motion.div
        key={location.pathname}
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 8 }}
        transition={{
          duration: DURATIONS.pageIn,
          ease: EASE,
          exit: { duration: DURATIONS.pageOut, ease: EASE },
        }}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
};

export default PageTransition;
